<template>
  <div id="card-kingdom">
    <!-- Starshine glitter effect from https://codepen.io/kucsatax/pen/vyWevX -->

    <div class="full-page">
      <div class="wallpaper">
        <!-- <div class="slider" v-if="show_main " >
          ข้าพระพุทธเจ้า <br />
          {{ name_only_one }}
        </div>
        <div class="slider" v-if="!show_main ">
          ข้าพระพุทธเจ้า

          <div
            v-for="(item, index) in show_names"
            :key="index"
            :class="[`slide${index + 1}`]"
          >
            {{ item.sign_name }}
          </div>
        </div> -->
        <!-- <div class="box">
          ข้าพระพุทธเจ้า
          <br />
          <ul class="swap">
            <li v-for="(item, index) in show_names" :key="index">
              {{ item.sign_name }}
            </li>
          </ul>
        </div> -->

        <div class="box">
          ข้าพระพุทธเจ้า
          <br />

          <ul class="swap">
            <li v-for="(item, index) in show_names" :key="index">
              &nbsp;&nbsp; &nbsp;{{ item.sign_name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
import axios from "axios";
import moment from "moment";
export default {
  name: "kingdom",
  data() {
    return {
      token: "NDMyMTNDNUYtRkZFNy00NjI1LUIwNTQtMkQ0QTkzOTIyQTM3",
      texts: "",
      chk_title: [],
      time_now: "",
      time_change: "",
      show_names: "",
      show_main: false,
      name_only_one:'',
      test:[{sign_name:'TEST Name'}]
    };
  },
  filters: {
    moment: function (date) {
      moment.locale("th");
      // if (date) {
      //   return moment(String(date)).format("MM/DD/YYYY");
      // }
      return moment(date).add(543, "year").format("LL");
    },
  },
  methods: {
    getIP() {
      this.getIPAddress().then((res) => {
        this.ipAddress = res.data.ip;
        localStorage.setItem("IP", this.ipAddress);
      });
    },
    getIPAddress() {
      return axios.get("https://api.ipify.org/?format=json");
    },
    getname() {
      const token_header = this.token;
      // this.chk_title = []
      let data = {
        token: this.token,
      };
      // console.log(data);
      const headers = {
        Authorization: `Bearer ${token_header}`,
      };
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/miracle/get_lastdata",
          data,
          { headers }
        )
        .then((res) => {
          // console.log("caed name == ", res);
          if (res.data.msg.status === 200) {
            this.texts = res.data.signed_datas;

            if (this.texts !== "") {
              this.chk_title.push(this.texts);
              // this.show_names = this.chk_title[0];
              this.show_names = this.chk_title[0].slice(0, 4);
              console.log( this.show_names);
              if( this.show_names.length ===1){
              this.show_main = true;
              // console.log(this.show_main);
             
              this.show_names.forEach((item) => {
                this.name_only_one =  item.sign_name;
              // console.log("chk", item.sign_name);
            });
            }else{
              this.show_main = false;
            }
            }
          
          
            // console.log("text==",this.texts);
          } else {
            alert(res.msg.message);
          }
        });
    },
    getlastTime() {
      const token_header = this.token;

      let data = {
        token: this.token,
      };
      // console.log(data);
      const headers = {
        Authorization: `Bearer ${token_header}`,
      };
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/miracle/get_lasttime",
          data,
          { headers }
        )
        .then((res) => {
          const time_update = res.data.created_date;
          // console.log(this.time_change.toString);
          // console.log(times);
          if (time_update !== this.time_change) {
            this.chk_title = [];
            this.time_change = res.data.created_date;
            // console.log("get time change", this.time_change);
            // this.chk_title = [];
            this.getname();
          }
        });
    },
  },
  mounted() {
    this.getIP();

    // setInterval(() => {
    this.getname();
    // },10000)
    setInterval(() => {
      this.getlastTime();
    }, 1000);

    // function loop($swap) {
    //   var next = $swap.find("li.visible").removeClass("visible").index() + 1;

    //   if (next >= $swap.find("li").length) {
    //     next = 0;
    //   }

    //   $swap.width(
    //     $($swap.find("li").get(next)).addClass("visible").outerWidth()
    //   );
    //   $swap.css({ transform: "translateY(-" + next * 3 + "rem)" });

    //   setTimeout(function () {
    //     loop($swap);
    //   }, 5000);
    // }

    // $(function () {
    //   $(".swap").each(function () {
    //     var $this = $(this);

    //     $this.find("li").each(function () {
    //       $(this).css({ top: $(this).index() * 3 + "rem" });
    //     });

    //     loop($this);
    //   });
    // });

    //
    const app = document.getElementById("app");

    const myRand = () => {
      let r = 50;
      while (40 < r && r < 60) {
        r = Math.random() * 100;
      }
      return r;
    };

    for (let i = 0; i < 50; i++) {
      const delay = Math.random() + "s";
      const el = document.createElement("img");
      el.className = "glitter-star";
      el.style.top = myRand() + "%";
      el.style.left = myRand() + "%";
      el.style.animationDelay = delay;
      el.style.msAnimationDelay = delay;
      el.style.webkitAnimationDelay = delay;
      el.style.monAnimationDelay = delay;
      app.appendChild(el);
    }
    // swap2
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Charm:wght@400;700&display=swap");
/* @import url('https://fonts.googleapis.com/css2?family=Srisakdi&display=swap'); */
/* @import url("https://fonts.googleapis.com/css2?family=Charmonman:wght@700&display=swap"); */
@font-face {
  font-family: "Chula";
  src: local("Chula"),
    url(./../../../../public//fonts/Chula-Fonts/ChulaCharasNewBold.ttf)
      format("truetype");
}

* {
  box-sizing: border-box;
}

.full-page .wallpaper {
  background: url("../../../assets/kingdom/card_02.png");
  /* background-repeat:no-repeat;
  background-position: center center; */
  background-size: cover;
  height: 100%;
  position: fixed;
  width: 100%;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  /* background-position: center top; */
}

ul {
  list-style-type: none;
}
/* color: #6e290e; */

/* text animations */

.box {
  position: absolute;
  top: 70%;
  left: 0;
  text-align: center;
  width: 100%;
  /* font-family: "Lato", sans-serif; */
  font-weight: bold;
  font-size: 2rem;
  text-stroke: 0.5px;
  color: #6e290e;
  /* font-family: "Chula"; */
  font-family: "Charm", cursive;
  /* font-family: 'Srisakdi', cursive; */
  /* font-family: "Charmonman", cursive; */
}
.box .swap {
  display: inline-block;
  position: relative;
  min-width: 1em;
  min-height: 1em;
  transition-duration: 0.5s;
  transition-property: transform width;
}
.box .swap li {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  white-space: nowrap;

  border-radius: 0.2em;
  padding: 0.2em 0.5em;
  /* background-color: #1abc9c; */
  /* color: #000000; */

  color: #6e290e;
  transition-duration: 0.5s;
  transition-property: opacity;
}
.box .swap li.visible {
  opacity: 1;
}

/* stars */

@keyframes glitter {
  0% {
    -webkit-transform: scale(1);
    opacity: 1;
  }
  25% {
    -webkit-transform: scale(0.5);
    opacity: 0;
  }
  50% {
    -webkit-transform: scale(1);
    opacity: 1;
  }
  75% {
    -webkit-transform: scale(0.5);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(1);
    opacity: 1;
  }
}

#app {
  margin: auto;
  width: auto;
  overflow: hidden;
}

img.glitter-star {
  border-radius: 50%;
  position: fixed;
  height: 20px;
  width: 20px;
  background-color: rgb(246, 238, 194);
  animation: glitter 2s linear 0s infinite normal;
}
/* swap */
.slider {
  max-width: 600px;
  height: 50px;
  margin: 20px auto;
  position: relative;
  font-weight: bold;
  font-size: 2rem;
  text-align: center;
  font-family: "Charm", cursive;
  margin-top: 70vh;
  color: #6e290e;
}

.slide1,
.slide2,
.slide3,
.slide4 {
  position: absolute;
  width: 100%;
  height: 100%;
  font-weight: bold;
  font-size: 2rem;
  font-family: "Charm", cursive;
  color: #6e290e;
}

.slide1 {
  /* animation: fade 60s infinite; */
  animation: fade 100s infinite;
  -webkit-animation: fade 100s infinite;
}
.slide2 {
  /* animation: fade2 60s infinite; */
  animation: fade2 100s infinite;
  -webkit-animation: fade2 100s infinite;
}
.slide3 {
  /* animation: fade3 60s infinite; */
  animation: fade3 100s infinite;
  -webkit-animation: fade3 100s infinite;
}
.slide4 {
  /* animation: fade4 60s infinite; */
  animation: fade4 100s infinite;
  -webkit-animation: fade4 100s infinite;
}
@keyframes fade {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  40% {
    opacity: 0;
  }
  60% {
    opacity: 0;
  }
  80% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fade2 {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  60% {
    opacity: 0;
  }
  80% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fade3 {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 0;
  }
  40% {
    opacity: 0;
  }
  60% {
    opacity: 1;
  }
  80% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fade4 {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 0;
  }
  40% {
    opacity: 0;
  }
  60% {
    opacity: 0;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes fadeinout
{
  0%{
    opacity:0;
  }
  50%
  {
    opacity:1;
  }
  100%
  {
    opacity:0;
  }
}

/* swap */
</style>